{
  "spec": {
    "units": {
      "cybermilla": {
        "id": "3aa0b021-294e-46c4-9743-0883884848e8",
        "input": {},
        "output": {},
        "metadata": {
          "position": {
            "x": 0,
            "y": 0
          },
          "component": {
            "width": 480,
            "height": 690
          }
        }
      }
    },
    "id": "d92282d8-1cf6-4297-8f53-9034f5ec80c5",
    "type": "`U`&`G`&`C`",
    "component": {
      "subComponents": {
        "cybermilla": {
          "children": []
        }
      },
      "children": ["cybermilla"],
      "defaultWidth": 480,
      "defaultHeight": 690
    },
    "render": true,
    "name": "cyber"
  },
  "specs": {
    "3aa0b021-294e-46c4-9743-0883884848e8": {
      "name": "cybermilla main",
      "inputs": {},
      "outputs": {},
      "units": {
        "box": {
          "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
          "input": {
            "style": {
              "constant": true,
              "data": "{\"position\":\"absolute\",\"background\":\"radial-gradient(circle, #07222E 0%, #061F2B 35%, #010B10 100%)\"}",
              "metadata": {
                "position": {
                  "x": -747,
                  "y": 143
                },
                "data": {
                  "position": {
                    "x": -630,
                    "y": 143
                  }
                }
              }
            },
            "attr": {
              "ignored": true,
              "metadata": {
                "position": {
                  "x": -748,
                  "y": 172
                }
              }
            }
          },
          "output": {},
          "metadata": {
            "position": {
              "x": -840,
              "y": 144
            }
          }
        },
        "box0": {
          "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
          "input": {
            "style": {
              "constant": true,
              "data": "{\"position\":\"absolute\",\"background-image\":\"url(background.png)\",\"opacity\":\"0.2\",\"background-position\":\"center\",\"height\":\"100%\"}",
              "metadata": {
                "position": {
                  "x": -437,
                  "y": -1220
                },
                "data": {
                  "position": {
                    "x": -320,
                    "y": -1220
                  }
                }
              }
            },
            "attr": {
              "ignored": true,
              "metadata": {
                "position": {
                  "x": -438,
                  "y": -1248
                }
              }
            }
          },
          "output": {},
          "metadata": {
            "position": {
              "x": -530,
              "y": -1219
            }
          }
        },
        "scrollsnapybox": {
          "id": "cef90fb7-bfcb-4f9d-8828-df6e68278601",
          "input": {
            "style": {
              "metadata": {
                "position": {
                  "x": 627,
                  "y": -943
                }
              }
            }
          },
          "output": {},
          "metadata": {
            "position": {
              "x": 780,
              "y": -943
            }
          }
        },
        "cybermilla0": {
          "id": "56304648-a9f7-483b-ac7d-2bc63f0bf67f",
          "input": {},
          "output": {
            "click": {}
          },
          "metadata": {
            "position": {
              "x": -177,
              "y": -207
            },
            "component": {
              "width": 488.36328125,
              "height": 669.35546875
            }
          }
        },
        "cybermilla1": {
          "id": "3d39256b-2982-48c1-ba48-be86f324057e",
          "input": {},
          "output": {},
          "metadata": {
            "position": {
              "x": 541,
              "y": -224
            }
          }
        },
        "cybermilla2": {
          "id": "550a6358-3466-4dcd-aa4c-012dc42919be",
          "input": {},
          "output": {},
          "metadata": {
            "position": {
              "x": -350,
              "y": 934
            }
          }
        },
        "wait": {
          "id": "ba38b0af-80c0-49e4-9e39-864396964ccc",
          "input": {
            "a": {
              "constant": true,
              "data": "{\"behavior\":\"smooth\",\"block\":\"center\"}",
              "metadata": {
                "position": {
                  "x": 119,
                  "y": -252
                },
                "data": {
                  "position": {
                    "x": 144,
                    "y": -310
                  }
                }
              }
            },
            "b": {
              "constant": false
            }
          },
          "output": {
            "a": {}
          },
          "metadata": {
            "position": {
              "x": 156,
              "y": -226
            }
          }
        },
        "scrollintoview": {
          "id": "de9665db-a188-4252-99f0-ea50fc343058",
          "input": {
            "component": {},
            "opt": {}
          },
          "output": {
            "done": {
              "ignored": true,
              "metadata": {
                "position": {
                  "x": 273,
                  "y": -185
                }
              }
            }
          },
          "metadata": {
            "position": {
              "x": 257,
              "y": -224
            }
          }
        }
      },
      "merges": {
        "0": {
          "scrollintoview": {
            "input": {
              "component": true
            }
          },
          "cybermilla1": {
            "output": {
              "_self": true
            }
          }
        },
        "1": {
          "wait": {
            "output": {
              "a": true
            }
          },
          "scrollintoview": {
            "input": {
              "opt": true
            }
          }
        },
        "2": {
          "cybermilla0": {
            "output": {
              "click": true
            }
          },
          "wait": {
            "input": {
              "b": true
            }
          }
        }
      },
      "render": true,
      "component": {
        "subComponents": {
          "cybermilla0": {
            "children": []
          },
          "cybermilla1": {
            "children": []
          },
          "cybermilla2": {
            "children": []
          },
          "scrollsnapybox": {
            "children": ["cybermilla0", "cybermilla1", "cybermilla2"],
            "width": 420,
            "height": 600
          },
          "box": {
            "children": []
          },
          "box0": {
            "children": []
          }
        },
        "children": ["box", "box0", "scrollsnapybox"],
        "defaultWidth": 480,
        "defaultHeight": 690
      },
      "metadata": {
        "complexity": 12,
        "position": {
          "merge": {
            "1": {
              "x": 207,
              "y": -225
            },
            "2": {
              "x": 104,
              "y": -215
            }
          }
        }
      },
      "id": "3aa0b021-294e-46c4-9743-0883884848e8",
      "type": "`U`&`G`&`C`"
    },
    "56304648-a9f7-483b-ac7d-2bc63f0bf67f": {
      "name": "cybermilla 0",
      "inputs": {},
      "outputs": {
        "click": {
          "plug": {
            "0": {
              "unitId": "onclick",
              "pinId": "event"
            },
            "1": {
              "unitId": "onclick0",
              "pinId": "event"
            },
            "2": {
              "unitId": "onclick1",
              "pinId": "event"
            }
          },
          "metadata": {
            "position": {
              "0": {
                "ext": {
                  "x": -502,
                  "y": -105
                }
              },
              "1": {
                "ext": {
                  "x": 105,
                  "y": -109
                }
              },
              "2": {
                "ext": {
                  "x": 680,
                  "y": -56
                }
              }
            }
          }
        }
      },
      "units": {
        "box": {
          "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
          "input": {
            "style": {
              "data": "{\"position\":\"relative\"}",
              "constant": true,
              "metadata": {
                "position": {
                  "x": -558,
                  "y": 538
                },
                "data": {
                  "position": {
                    "x": -653,
                    "y": 538
                  }
                }
              }
            },
            "attr": {
              "ignored": true,
              "metadata": {
                "position": {
                  "x": -558,
                  "y": 492
                }
              }
            }
          },
          "output": {},
          "metadata": {
            "component": {
              "width": 399.77978515625,
              "height": 482.120849609375
            },
            "position": {
              "x": -325,
              "y": 538
            }
          }
        },
        "box4": {
          "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
          "input": {
            "style": {
              "data": "{\"position\":\"absolute\",\"top\":\"50%\",\"left\":\"50%\",\"transform\":\"translate(-50%,-50%)\",\"display\":\"flex\",\"flexDirection\":\"column\",\"alignContent\":\"center\",\"alignItems\":\"center\",\"width\":\"fit-content\",\"height\":\"fit-content\",\"maxWidth\":\"calc(100% - 24px)\"}",
              "constant": true,
              "metadata": {
                "position": {
                  "x": 663,
                  "y": -372
                },
                "data": {
                  "position": {
                    "x": 547,
                    "y": -372
                  }
                }
              }
            },
            "attr": {
              "ignored": true,
              "metadata": {
                "position": {
                  "x": 664,
                  "y": -420
                }
              }
            }
          },
          "output": {},
          "metadata": {
            "position": {
              "x": 915,
              "y": -372
            },
            "component": {
              "width": 437.25,
              "height": 545
            }
          }
        },
        "box5": {
          "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
          "input": {
            "style": {
              "data": "{\"display\":\"flex\",\"flexDirection\":\"row\",\"justifyContent\":\"center\",\"alignItems\":\"center\",\"flexWrap\":\"wrap\",\"width\":\"100%\",\"height\":\"fit-content\",\"gap\":\"12px\",\"margin\":\"24px 0 0 0\"}",
              "constant": true,
              "metadata": {
                "position": {
                  "x": 211,
                  "y": 296
                },
                "data": {
                  "position": {
                    "x": 101,
                    "y": 296
                  }
                }
              }
            },
            "attr": {
              "ignored": true,
              "metadata": {
                "position": {
                  "x": 211,
                  "y": 267
                }
              }
            }
          },
          "output": {},
          "metadata": {
            "component": {
              "width": 661.219482421875,
              "height": 82.2640380859375
            },
            "position": {
              "x": 575,
              "y": 296
            }
          }
        },
        "textdiv": {
          "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
          "input": {
            "style": {
              "data": "{\"height\":\"fit-content\",\"textAlign\":\"center\",\"fontSize\":\"28px\",\"margin\":\"9px\"}",
              "constant": true,
              "metadata": {
                "position": {
                  "x": -747,
                  "y": -511
                },
                "data": {
                  "position": {
                    "x": -850,
                    "y": -543
                  }
                }
              }
            },
            "value": {
              "data": "\"Camilla Merlo\"",
              "metadata": {
                "position": {
                  "x": -747,
                  "y": -445
                }
              }
            },
            "attr": {
              "metadata": {
                "position": {
                  "x": -747,
                  "y": -478
                }
              }
            }
          },
          "output": {
            "div": {
              "ignored": true,
              "metadata": {
                "position": {
                  "x": -718,
                  "y": -512
                }
              }
            },
            "value": {
              "metadata": {
                "position": {
                  "x": -245,
                  "y": -478
                }
              }
            }
          },
          "metadata": {
            "component": {
              "width": 435.208740234375,
              "height": 56.8240966796875
            },
            "position": {
              "x": -496,
              "y": -478
            }
          }
        },
        "textdiv0": {
          "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
          "input": {
            "style": {
              "data": "{\"height\":\"fit-content\",\"textAlign\":\"center\",\"fontSize\":\"75px\",\"margin\":\"6px\"}",
              "constant": true,
              "metadata": {
                "position": {
                  "x": -294,
                  "y": -336
                },
                "data": {
                  "position": {
                    "x": -398,
                    "y": -364
                  }
                }
              }
            },
            "value": {
              "data": "\"Portfolio\"",
              "metadata": {
                "position": {
                  "x": -295,
                  "y": -303
                }
              }
            },
            "attr": {
              "metadata": {
                "position": {
                  "x": -294,
                  "y": -270
                }
              }
            }
          },
          "output": {
            "div": {
              "ignored": true,
              "metadata": {
                "position": {
                  "x": -302,
                  "y": -363
                }
              }
            },
            "value": {
              "metadata": {
                "position": {
                  "x": 212,
                  "y": -303
                }
              }
            }
          },
          "metadata": {
            "component": {
              "width": 440.134033203125,
              "height": 120
            },
            "position": {
              "x": -41,
              "y": -303
            }
          }
        },
        "image": {
          "id": "059579bb-184f-435b-ace0-64ec95c9f125",
          "input": {
            "style": {
              "data": "{\"borderRadius\":\"50%\",\"width\":\"172px\",\"height\":\"172px\",\"border\":\"3px solid white\",\"marginBottom\":\"15px\",\"background\":\"#F5F5F5\"}",
              "constant": true,
              "metadata": {
                "position": {
                  "x": -181,
                  "y": -679
                },
                "data": {
                  "position": {
                    "x": -296,
                    "y": -710
                  }
                }
              }
            },
            "src": {
              "data": "\"avatar.png\"",
              "metadata": {
                "position": {
                  "x": -181,
                  "y": -633
                }
              }
            },
            "attr": {
              "ignored": true,
              "metadata": {
                "position": {
                  "x": -179,
                  "y": -603
                }
              }
            }
          },
          "output": {},
          "metadata": {
            "component": {
              "width": 262.4488525390625,
              "height": 244.4654541015625
            },
            "position": {
              "x": -17,
              "y": -656
            }
          }
        },
        "cybermillabutton": {
          "id": "adce949f-82db-4c67-872b-4c80ed5dd643",
          "input": {
            "style": {
              "data": "{\"background\":\"radial-gradient(ellipse at center, #ffffff -100%, #FD5F55 50%)\"}",
              "constant": true,
              "metadata": {
                "position": {
                  "x": -925,
                  "y": -124
                },
                "data": {
                  "position": {
                    "x": -1042,
                    "y": -143
                  }
                }
              }
            },
            "value": {
              "data": "\"Fashion\"",
              "metadata": {
                "position": {
                  "x": -925,
                  "y": -86
                },
                "data": {
                  "position": {
                    "x": -976,
                    "y": -76
                  }
                }
              },
              "constant": true
            }
          },
          "output": {},
          "metadata": {
            "component": {
              "width": 274.7310791015625,
              "height": 122.5975341796875
            },
            "position": {
              "x": -754,
              "y": -105
            }
          }
        },
        "onclick": {
          "id": "97c94516-add1-11ea-ba72-8f55299b735c",
          "input": {
            "element": {}
          },
          "output": {
            "event": {
              "metadata": {
                "position": {
                  "x": -524,
                  "y": -105
                }
              }
            }
          },
          "metadata": {
            "position": {
              "x": -573,
              "y": -105
            }
          }
        },
        "onclick0": {
          "id": "97c94516-add1-11ea-ba72-8f55299b735c",
          "input": {
            "element": {}
          },
          "output": {
            "event": {
              "metadata": {
                "position": {
                  "x": 82,
                  "y": -109
                }
              }
            }
          },
          "metadata": {
            "position": {
              "x": 34,
              "y": -109
            }
          }
        },
        "onclick1": {
          "id": "97c94516-add1-11ea-ba72-8f55299b735c",
          "input": {
            "element": {}
          },
          "output": {
            "event": {
              "metadata": {
                "position": {
                  "x": 662,
                  "y": -70
                }
              }
            }
          },
          "metadata": {
            "position": {
              "x": 613,
              "y": -70
            }
          }
        },
        "cybermillabutton2": {
          "id": "adce949f-82db-4c67-872b-4c80ed5dd643",
          "input": {
            "style": {
              "data": "{\"background\":\"radial-gradient(ellipse at center, #ffffff -100%, #A6496A 50%)\"}",
              "constant": true,
              "metadata": {
                "position": {
                  "x": -320,
                  "y": -128
                },
                "data": {
                  "position": {
                    "x": -425,
                    "y": -162
                  }
                }
              }
            },
            "value": {
              "data": "\"Design\"",
              "metadata": {
                "position": {
                  "x": -320,
                  "y": -90
                },
                "data": {
                  "position": {
                    "x": -368,
                    "y": -80
                  }
                }
              },
              "constant": true
            }
          },
          "output": {},
          "metadata": {
            "component": {
              "width": 277,
              "height": 125
            },
            "position": {
              "x": -149,
              "y": -109
            }
          }
        },
        "cybermillabutton0": {
          "id": "adce949f-82db-4c67-872b-4c80ed5dd643",
          "input": {
            "style": {
              "data": "{\"background\":\"radial-gradient(ellipse at center, #ffffff -100%, #7D222B 50%)\"}",
              "constant": true,
              "metadata": {
                "position": {
                  "x": 257,
                  "y": -89
                },
                "data": {
                  "position": {
                    "x": 197,
                    "y": -140
                  }
                }
              }
            },
            "value": {
              "data": "\"Audiovisual\"",
              "metadata": {
                "position": {
                  "x": 257,
                  "y": -50
                },
                "data": {
                  "position": {
                    "x": 194,
                    "y": -39
                  }
                }
              },
              "constant": true
            }
          },
          "output": {},
          "metadata": {
            "component": {
              "width": 279,
              "height": 127
            },
            "position": {
              "x": 430,
              "y": -70
            }
          }
        }
      },
      "merges": {
        "0": {
          "onclick": {
            "input": {
              "element": true
            }
          },
          "cybermillabutton": {
            "output": {
              "_self": true
            }
          }
        },
        "1": {
          "onclick0": {
            "input": {
              "element": true
            }
          },
          "cybermillabutton2": {
            "output": {
              "_self": true
            }
          }
        },
        "2": {
          "onclick1": {
            "input": {
              "element": true
            }
          },
          "cybermillabutton0": {
            "output": {
              "_self": true
            }
          }
        }
      },
      "render": true,
      "component": {
        "subComponents": {
          "box": {
            "children": ["box4"],
            "childSlot": {
              "box4": "default"
            },
            "width": 483.875,
            "height": 627.1640625
          },
          "box4": {
            "children": ["image", "textdiv", "textdiv0", "box5"],
            "childSlot": {
              "image": "default",
              "textdiv": "default",
              "textdiv0": "default",
              "box5": "default"
            }
          },
          "box5": {
            "children": [
              "cybermillabutton",
              "cybermillabutton2",
              "cybermillabutton0"
            ],
            "childSlot": {
              "cybermillabutton": "default"
            }
          },
          "textdiv": {
            "children": []
          },
          "textdiv0": {
            "children": []
          },
          "image": {
            "children": []
          },
          "cybermillabutton": {
            "children": []
          },
          "cybermillabutton2": {},
          "cybermillabutton0": {}
        },
        "children": ["box"],
        "defaultWidth": 274.7310791015625,
        "defaultHeight": 122.5975341796875
      },
      "metadata": {},
      "type": "`U`&`G`&`C`",
      "id": "56304648-a9f7-483b-ac7d-2bc63f0bf67f"
    },
    "adce949f-82db-4c67-872b-4c80ed5dd643": {
      "name": "cybermilla button",
      "units": {
        "textdiv": {
          "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
          "input": {
            "value": {
              "metadata": {
                "position": {
                  "x": 0,
                  "y": 97
                }
              }
            },
            "style": {},
            "attr": {}
          },
          "output": {
            "div": {
              "ignored": true,
              "metadata": {
                "position": {
                  "x": 316,
                  "y": 76
                }
              }
            },
            "value": {}
          },
          "metadata": {
            "position": {
              "x": 173,
              "y": 91
            }
          }
        },
        "mergedefault": {
          "id": "304e98ac-bda1-11ea-b416-9746f024148c",
          "input": {
            "default": {
              "data": "{\"width\":\"210px\",\"height\":\"45.5px\",\"textAlign\":\"center\",\"fontSize\":\"26px\",\"padding\":\"9px\",\"borderRadius\":\"6px\",\"cursor\":\"pointer\",\"boxShadow\":\"6px 6px 8px 0px rgba(0,0,0,0.75)\",\"userSelect\":\"none\",\"boxSizing\":\"border-box\"}",
              "constant": true,
              "metadata": {
                "position": {
                  "x": -105,
                  "y": 20
                }
              }
            },
            "a": {
              "metadata": {
                "position": {
                  "x": -108,
                  "y": 55
                }
              }
            }
          },
          "output": {
            "a": {}
          },
          "metadata": {
            "position": {
              "x": -143,
              "y": -14
            }
          }
        }
      },
      "merges": {
        "0": {
          "mergedefault": {
            "output": {
              "a": true
            }
          },
          "textdiv": {
            "input": {
              "style": true
            }
          }
        }
      },
      "inputs": {
        "style": {
          "plug": {
            "0": {
              "unitId": "mergedefault",
              "pinId": "a"
            }
          }
        },
        "value": {
          "plug": {
            "0": {
              "unitId": "textdiv",
              "pinId": "value"
            }
          }
        }
      },
      "component": {
        "subComponents": {
          "textdiv": {}
        },
        "children": ["textdiv"],
        "defaultWidth": 300,
        "defaultHeight": 420
      },
      "render": true,
      "type": "`U`&`G`&`C`",
      "id": "adce949f-82db-4c67-872b-4c80ed5dd643"
    },
    "3d39256b-2982-48c1-ba48-be86f324057e": {
      "name": "cybermilla 1",
      "units": {
        "horizontalscrollbox": {
          "id": "ec8afd36-0718-42f7-9b0d-4b1adbf62766",
          "input": {
            "style": {
              "data": "{\"position\":\"absolute\",\"top\":\"50%\",\"left\":\"50%\",\"transform\":\"translate(-50%,-50%)\",\"display\":\"flex\",\"flexDirection\":\"column\",\"alignContent\":\"center\",\"alignItems\":\"center\",\"width\":\"calc(100% - 60px)\",\"height\":\"auto\",\"aspect-ratio\":\"16/9\",\"maxWidth\":\"calc(100% - 24px)\",\"border\":\"1px solid #F5F5F5\"}",
              "constant": true
            }
          },
          "output": {}
        },
        "box": {
          "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
          "input": {
            "style": {
              "data": "{\"position\":\"relative\",\"display\":\"flex\",\"flexDirection\":\"row\",\"justifyContent\":\"center\",\"alignItems\":\"center\",\"flexWrap\":\"wrap\",\"gap\":\"12px\"}",
              "constant": true
            },
            "attr": {
              "ignored": true
            }
          },
          "output": {}
        }
      },
      "component": {
        "slots": [["box", "default"]],
        "subComponents": {
          "box": {
            "children": ["horizontalscrollbox"]
          },
          "horizontalscrollbox": {}
        },
        "children": ["box"],
        "defaultWidth": 480,
        "defaultHeight": 690
      },
      "render": true,
      "type": "`U`&`G`&`C`",
      "id": "3d39256b-2982-48c1-ba48-be86f324057e"
    },
    "550a6358-3466-4dcd-aa4c-012dc42919be": {
      "name": "cybermilla 2",
      "units": {
        "cybermillaabout": {
          "id": "acf5cdc4-2bb7-47de-9c7d-b34d37e30663",
          "input": {},
          "output": {}
        },
        "box0": {
          "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
          "input": {
            "style": {
              "data": "{position:\"absolute\",top:'50%',left:'50%',transform:'translate(-50%,-50%)',display:'flex',flexDirection:\"column\",alignContent:\"center\",alignItems:\"center\",width:\"420px\",height:\"300px\",maxWidth:\"calc(100% - 24px)\"}"
            },
            "attr": {
              "ignored": true
            }
          },
          "output": {}
        },
        "box": {
          "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
          "input": {
            "style": {
              "data": "{position:\"relative\",display:'flex',flexDirection:\"row\",justifyContent:\"center\",alignItems:\"center\",flexWrap:\"wrap\",gap:\"12px\"}"
            },
            "attr": {
              "ignored": true
            }
          },
          "output": {}
        }
      },
      "component": {
        "subComponents": {
          "box": {
            "children": ["box0"]
          },
          "box0": {
            "children": ["cybermillaabout"]
          },
          "cybermillaabout": {}
        },
        "children": ["box"],
        "defaultWidth": 480,
        "defaultHeight": 690
      },
      "render": true,
      "type": "`U`&`G`&`C`",
      "id": "550a6358-3466-4dcd-aa4c-012dc42919be"
    },
    "acf5cdc4-2bb7-47de-9c7d-b34d37e30663": {
      "name": "cybermilla about",
      "units": {
        "box": {
          "id": "9eba84b6-d2ca-47e6-9195-8208dbb880bc",
          "input": {
            "style": {
              "data": "{display:'flex',flexDirection:\"column\",alignContent:\"center\",alignItems:\"center\",gap:\"6px\",fontSize:\"24px\",textAlign:\"center\"}"
            },
            "attr": {
              "ignored": true
            }
          },
          "output": {}
        },
        "textdiv": {
          "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
          "input": {
            "style": {
              "data": "{height:'fit-content',fontSize:'60px',marginBottom:'12px',padding:'12px',backgroundColor:'#D9D9D911'}"
            },
            "value": {
              "data": "'About'"
            },
            "attr": {}
          },
          "output": {
            "div": {
              "ignored": true
            },
            "value": {}
          }
        },
        "textdiv0": {
          "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
          "input": {
            "style": {
              "data": "{height:'fit-content'}"
            },
            "value": {
              "data": "'Camilla Merlo'"
            },
            "attr": {}
          },
          "output": {
            "div": {
              "ignored": true
            },
            "value": {}
          }
        },
        "textdiv1": {
          "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
          "input": {
            "style": {
              "data": "{height:'fit-content'}"
            },
            "value": {
              "data": "'Creative Designer'"
            },
            "attr": {}
          },
          "output": {
            "div": {
              "ignored": true
            },
            "value": {}
          }
        },
        "textdiv2": {
          "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
          "input": {
            "style": {
              "data": "{height:'fit-content'}"
            },
            "value": {
              "data": "'cmllmerlo@gmail.com'"
            },
            "attr": {}
          },
          "output": {
            "div": {
              "ignored": true
            },
            "value": {}
          }
        },
        "textdiv3": {
          "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
          "input": {
            "style": {
              "data": "{height:'fit-content'}"
            },
            "value": {
              "data": "'São Paulo - SP'"
            },
            "attr": {}
          },
          "output": {
            "div": {
              "ignored": true
            },
            "value": {}
          }
        },
        "textdiv4": {
          "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
          "input": {
            "style": {
              "data": "{height:'fit-content'}"
            },
            "value": {
              "data": "'Brasil'"
            },
            "attr": {}
          },
          "output": {
            "div": {
              "ignored": true
            },
            "value": {}
          }
        },
        "textdiv5": {
          "id": "9988a56e-6bee-46c8-864c-e351d84bc7e2",
          "input": {
            "style": {
              "data": "{height:'fit-content'}"
            },
            "value": {
              "data": "'CV'"
            },
            "attr": {}
          },
          "output": {
            "div": {
              "ignored": true
            },
            "value": {}
          }
        }
      },
      "merges": {},
      "inputs": {},
      "component": {
        "subComponents": {
          "box": {
            "children": [
              "textdiv",
              "textdiv0",
              "textdiv1",
              "textdiv2",
              "textdiv3",
              "textdiv4",
              "textdiv5"
            ]
          },
          "textdiv": {},
          "textdiv0": {},
          "textdiv1": {},
          "textdiv2": {},
          "textdiv3": {},
          "textdiv4": {},
          "textdiv5": {}
        },
        "children": ["box"],
        "defaultWidth": 300,
        "defaultHeight": 420
      },
      "render": true,
      "id": "acf5cdc4-2bb7-47de-9c7d-b34d37e30663"
    }
  }
}
